// extracted by mini-css-extract-plugin
export default {"form-select":"Select_form-select__VjkUb","custom-select-variant-1":"Select_custom-select-variant-1__IOkQK","custom-select-variant-2":"Select_custom-select-variant-2__BwCzf"};